import { render, staticRenderFns } from "./TaskElement.vue?vue&type=template&id=009cdde8"
import script from "./TaskElement.vue?vue&type=script&lang=js"
export * from "./TaskElement.vue?vue&type=script&lang=js"
import style0 from "./TaskElement.vue?vue&type=style&index=0&id=009cdde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports